// config
import * as http from 'utils/http';
import config from 'config';
// utils

const getWorkingAreas = async () => {
  const data = await http.get(`${config.API_URL}price-negotiation/working-areas?page_size=0`);
  return data;
};

export default getWorkingAreas;
